import Form from "components/Form";
import WithFormField from "components/Form/WithFormField";

import ControlledEmailInput from "./ControlledEmailInput/ControlledEmailInput";
import ControlledPermissionDropdown from "./ControlledPermissionDropdown";

const InputController = Form.Input;
const DropdownController = WithFormField(ControlledPermissionDropdown);
const CheckboxController = Form.Checkbox;
const EmailController = WithFormField(ControlledEmailInput);

export {
  ErrorMessage,
  PermissionTooltip,
} from "../../AddUserModal/components/NewUserInfoPage/components";

export {
  InputController,
  EmailController,
  CheckboxController,
  DropdownController,
};
